/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { colors } from '_styles';

export default styled.button`
  display: block;
  border-radius: 4px;
  padding: ${(props) => (props.padding ? props.padding : '9px 12px')};
  font-weight: 500 !important;
  font-family: Roboto, sans-serif !important;
  cursor: pointer;
  border: 1px solid transparent;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '13px !important')};
  margin: ${({ margin }) => margin};
  text-transform: capitalize;
  background-color: ${({ mainColor, backgroundColor }) => (mainColor ? `#${mainColor}` : backgroundColor ? `#${backgroundColor}` : `${colors.LIGHT_BLUE}`)};
  color: ${(props) => (props.color ? props.color : 'white')};
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: all .3s;
  
  &:hover {
    color: ${({ mainColor }) => (mainColor ? `#${mainColor}` : `${colors.LIGHT_BLUE}`)};
    background-color: #fff;
    border: ${({ mainColor }) => (mainColor ? `1px solid #${mainColor}` : `1px solid ${colors.LIGHT_BLUE}`)};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 4px 0px;
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.3;
    background-color: ${({ mainColor, backgroundColor }) => (mainColor ? `#${mainColor}` : backgroundColor ? `#${backgroundColor}` : `${colors.LIGHT_BLUE}`)};
    color: ${(props) => (props.color ? props.color : 'white')};
  }
`;
